import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './svg.css';

const HamburgerMenu = ({ className }) => (
  <svg
    className={classnames(
      styles.HamburgerCommon,
      className || styles.HamburgerDefault
    )}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 20 16"
  >
    <title>HamburgerMenu</title>
    <path
      className="st0"
      d="M16.5,6.6H3.5C2.7,6.6,2,7.2,2,8s0.6,1.4,1.4,1.4h13.1C17.3,9.4,18,8.8,18,8C18,7.2,17.3,6.6,16.5,6.6z"
    />
    <path
      className="st0"
      d="M3.5,4.4h13.1c0.8,0,1.4-0.5,1.4-1.3c0,0,0,0,0,0c0-0.8-0.7-1.4-1.4-1.3H3.5C2.7,1.6,2,2.2,2,3c0,0,0,0,0,0
      C2,3.8,2.7,4.4,3.5,4.4C3.4,4.4,3.4,4.4,3.5,4.4z"
    />
    <path
      className="st0"
      d="M16.5,11.6H3.5c-0.7,0-1.3,0.6-1.3,1.3s0.6,1.3,1.3,1.3h13.1c0.8,0,1.4-0.5,1.4-1.3c0,0,0,0,0,0
	  c0-0.4-0.1-0.7-0.4-0.9C17.3,11.8,16.9,11.6,16.5,11.6z"
    />
  </svg>
);
HamburgerMenu.propTypes = {
  className: PropTypes.string,
};
export default HamburgerMenu;



// WEBPACK FOOTER //
// ./src/assets/HamburgerMenu.jsx